module.exports = __webpack_public_path__ + "img/fondopancho.f47a2374.jpg";